const constants = {
    IMAGES_AMOUNT: 8,
    MAIN_PAGE: "random_images",
    METRICS: {
        dogs: "loadDogsImages",
        cats: "loadCatsImages",
        randImages: "loadRandomImages",
    },
    GUID: "77d20161-ec5b-4cc1-b324-723096f7e4c7",
    // GUID: "23dc66db-ec6f-4314-89f8-f1d2256dfd39",
};

module.exports = constants;
